import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import {v4 as uuidv4} from 'uuid';


const EquipmentService_modal = (props) => {
    const [show, setShow] = useState(false);
    let {equipmentService_modal, rerender, id} = props;
    useEffect(() => {
        if (equipmentService_modal[0].name !== "")
            setShow(true)
    }, [rerender]);

    const handleClose = () => setShow(false);


    // console.log(props)
    return (
        <div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5 className="modal-title" id="viewModal"> Service Equipments</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="services-list-sect">
                        {equipmentService_modal.length > 0 ? equipmentService_modal.map((equipments) => (

                            <div className="card h-100 mb-3" key={uuidv4()}>
                                <div className="row no-gutters">
                                    <div className="col-md-4">
                                        <div className="card-image-holder-idea-4">
                                            <img src={equipments.image}
                                                 className="card-img-top w-100 h-100 obj-fit" alt="..."/>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="card-body">
                                            <h5 className="card-title">{equipments.name}</h5>
                                            <p className="card-text">Manufacturer: {equipments.manufacturer}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )) : <span>No data to display</span>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-lg-3 mb-3" onClick={handleClose}>
                        <div className="btn btn-sm btn-block btn-danger">Close</div>
                    </div>
                    <div className="col-lg-3 mb-3">
                        <Link to={`/farmer/checkout/${id}`} className="btn btn-sm btn-block btn-orange">Hire</Link>
                    </div>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default EquipmentService_modal